import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import GrossProfitReport from "../@Components/Products/GrossProfitReport";

const GrossProfitPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <GrossProfitReport />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default GrossProfitPage;
